import { createAction } from 'redux-action';

const initialState = {
  problems: [],
  test_cases: [],
  problem: {},
  problemDetails: [],
  tags: {},
  loading: false,
  error: null,
};

const SET_PROBLEMS = 'SET_PROBLEMS';
const SET_PROBLEM_TEST_CASES = 'SET_PROBLEM_TEST_CASES';
const SET_PROBLEM_DETAILS = 'SET_PROBLEM_DETAILS';
const SET_LOADING = 'SET_LOADING';
const SET_ERROR = 'SET_ERROR';

export const setProblems = createAction(SET_PROBLEMS);
export const setProblemTestCases = createAction(SET_PROBLEM_TEST_CASES);
export const setProblemDetails = createAction(SET_PROBLEM_DETAILS);
export const setLoading = createAction(SET_LOADING);
export const setError = createAction(SET_ERROR);

const problemReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROBLEMS:
      const updatedTags = action.payload.tags.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      return {
        ...state,
        problems: action.payload.problems,
        tags: updatedTags,
        loading: false,
      };
    case SET_PROBLEM_TEST_CASES:
      return {
        ...state,
        test_cases: action.payload || [],
        loading: false,
      };
    case SET_PROBLEM_DETAILS:
      const newProblemDetails = Array.isArray(action.payload) ? action.payload : [];
      return {
        ...state,
        problemDetails: newProblemDetails,
        loading: false,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default problemReducer;
